import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { instructionsData } from './data/instructionsData';
import VideoPlayer from './VideoPlayer';
import './scss/Instructions.scss';

function Instructions() {

  const [sections, setSections] = useState(instructionsData);

  // expand all sections screen is wider than 1199px
  useEffect(() => {
    if (window.innerWidth > 1199) {
      setSections(
        sections.map((section, index) => {
          return { ...section, isCollapsed: false };
        })
      )
    }
  }, []);

  function toggleSection(e) {
    const sectionIndex = Number(e.currentTarget.dataset.index);
    setSections(
      // create a new array with updates
      sections.map((section, index) => {
        if (index === sectionIndex) {
          // toggle displayVideo
          return { ...section, isCollapsed: !section.isCollapsed };
        } else {
          return section;
        }
      })
    )
  }

  function toggleAllSections() {
    setSections(
      sections.map((section, index) => {
        // if at least 1 section is collapsed, button will be "Expand all"
        if (sections.some(section => section.isCollapsed === true)) {
          return { ...section, isCollapsed: false };
        // otherwise, if all are expanded, button will be "Collapse all"
        } else {
          return { ...section, isCollapsed: true };
        }
      })
    )
  }

  function toggleVideoText(e) {
    const sectionIndex = Number(e.target.dataset.index);
    setSections(
      // create a new array with updates
      sections.map((section, index) => {
        if (index === sectionIndex) {
          // toggle displayVideo
          return { ...section, displayVideo: !section.displayVideo };
        } else {
          return section;
        }
      })
    )
  }

  return (
    <section id="instructions">
      <div id="instructions-header">
        <h2>Steps</h2>
        <button onClick={toggleAllSections}>
          {sections.some(section => section.isCollapsed === true) ? 'Expand' : 'Collapse'} all
        </button>
      </div>

      {sections.map((section, index) =>
        <section 
          id={section.id} 
          key={section.id} 
          className="collapsible"
          data-collapsed={section.isCollapsed}
        >
          <div className="section-header">
            <h3 data-index={index} onClick={toggleSection}>{index+1}) {section.name}</h3>
            {section.videos ? 
              <button 
                onClick={toggleVideoText}
                className={`icon ${!section.displayVideo ? "text" : "video"}`}
                data-index={index}>
              </button>
            : null }
          </div>
          <div className={`section-content ${!section.displayVideo ? "showText" : "showVideo"}`}>
            <div className="text">
              <div className="steps-container">
                <ul className="prep-steps">
                  {section.steps.map((step, index) =>
                    <li key={index}>{parse(step.text)}</li>
                  )}
                </ul>
              </div>
            </div>
            { section.videos ? 
              <VideoPlayer videos={section.videos}/>
            : null }
          </div>
        </section>
      )}
    </section>
  );
}

export default Instructions;
